import flatten from 'flat';
import home from './fr-FR/home';

export default flatten({
  ...home,
});
